import * as React from 'react';

export interface ISTIconProps {
  color?: string;
  size?: string | number;
  title?: string;
}

export const STIcon = React.forwardRef<SVGSVGElement, ISTIconProps>(
  ({ color = 'currentColor', size = '1em', title = null, ...rest }, ref) => {
    return (
      <svg
        ref={ref}
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 16 16"
        width={size}
        height={size}
        fill={color}
        {...rest}
      >
        {title ? <title>{title}</title> : null}
        <g xmlns="http://www.w3.org/2000/svg" transform="matrix(1.0404 0 0 1.0404 -98.016 -47.497)">
          <g fontFamily="sans-serif" fontSize="10.583px" wordSpacing="0px" aria-label="T 1">
            <g
              transform="matrix(.92985 0 0 .86537 6.8704 6.826)"
              fontFamily="sans-serif"
              fontSize="10.583px"
              aria-label="T1"
            >
              <g
                transform="matrix(3.0828,0,0,3.3126,-203.5,-95.579)"
                fontFamily="sans-serif"
                fontSize="8.652px"
                strokeWidth=".0072031"
                aria-label="T1"
              >
                <text x="97.087555" y="47.709003" fontFamily="sans-serif" fontSize="4.6513px" xmlSpace="preserve">
                  <tspan x="97.087555" y="47.709003" strokeWidth=".0072031" />
                </text>
                <g aria-label="T1">
                  <path d="m99.233 43.283q0-0.19967 0.19967-0.19967h1.9967q0.19967 0 0.19967 0.19967t-0.19967 0.19967h-0.79867v3.3943q0 0.19967-0.19967 0.19967t-0.19967-0.19967v-3.3943h-0.79867q-0.19967 0-0.19967-0.19967z" />
                  <g transform="scale(.9737 1.027)" strokeWidth=".0024804" aria-label="S">
                    <path
                      d="m101.89 44.88q0 0.40614-0.28967 0.69581-0.28967 0.28967-0.6958 0.28967-0.72866 0-1.2931-0.43003-0.0866-0.0657-0.0866-0.16126 0-0.08063 0.05674-0.13737 0.05973-0.05973 0.14036-0.05973 0.04778 0 0.11348 0.03583 0.1732 0.10452 0.5435 0.27474 0.24189 0.08362 0.52559 0.08362 0.24487 0 0.41808-0.1732 0.1732-0.1732 0.1732-0.41808 0-0.36134-0.32849-0.52857l-1.1079-0.5674q-0.53454-0.27474-0.53454-0.87498 0-0.40614 0.28967-0.69581 0.28967-0.28967 0.6958-0.28967 0.6988 0 1.0661 0.21501 0.11647 0.06869 0.11647 0.17918 0 0.08063-0.0597 0.14036-0.0567 0.05674-0.13737 0.05674-0.0299 0-0.0836-0.0209-0.45392-0.17619-0.90187-0.17619-0.24487 0-0.41808 0.1732-0.1732 0.1732-0.1732 0.41808 0 0.36134 0.32252 0.52559l1.1079 0.5674q0.54052 0.27773 0.54052 0.87797z"
                      strokeWidth=".0024804"
                    />
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
      </svg>
    );
  },
);
